import React, { useMemo } from 'react';
import styled from 'styled-components';
import { localizationService } from '@shared-services/localization-service';

const CalBooking = () => {
    const date = useMemo(() => {
        const today = new Date();
        return {
            year: today.getFullYear(),
            month: today.toLocaleString('default', { month: 'long' }),
            day: today.getDate(),
            dayInWeek: today.toLocaleString('default', { weekday: 'long' }),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    }, []);

    const mockInfo = {
        userName: localizationService.str(
            'ui.runtimessr.calbooking.markup.userName'
        ),
        eventName: localizationService.str(
            'ui.runtimessr.calbooking.markup.eventType'
        ),
        data: [
            {
                value: '30m',
                icon: '⏱',
            },
            {
                value: 'Online Meeting',
                icon: '🗓️',
            },
            {
                value: date.timeZone,
                icon: '🌐',
            },
        ],
    };
    return (
        <Wrapper>
            <Sidebar>
                <Heading>{mockInfo.userName}</Heading>
                <Subheading>{mockInfo.eventName}</Subheading>
                {mockInfo.data.map((item, index) => (
                    <Info key={index}>
                        <span>{item.icon}</span> {item.value}
                    </Info>
                ))}
            </Sidebar>
            <CalendarWrapper>
                <Heading>
                    <span>{date.month}</span> <span>{date.year}</span>
                </Heading>
                <Calendar>
                    {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(
                        (day) => (
                            <Day key={day}>{day}</Day>
                        )
                    )}
                    {[...Array(31)].map((_, i) => {
                        const day = i + 1;
                        const currentDay = date.day;
                        const isCurrentDay = day === currentDay;
                        const isInvalidDay = day < currentDay;
                        return isCurrentDay ? (
                            <CurrentDateCell>{day}</CurrentDateCell>
                        ) : (
                            <DateCell key={i} isInvalidDay={isInvalidDay}>
                                {day}
                            </DateCell>
                        );
                    })}
                </Calendar>
            </CalendarWrapper>
            <TimeslotsWrapper>
                <TimeslotHead>
                    <span>{`${date.dayInWeek} ${date.day}`}</span>
                    <TimeToggle>
                        <span>12h</span>
                        <span>24h</span>
                    </TimeToggle>
                </TimeslotHead>
                <Slots />
            </TimeslotsWrapper>
        </Wrapper>
    );
};

function Slots() {
    return (
        <SlotsList>
            {[
                '9:00am',
                '9:30am',
                '11:00am',
                '11:30am',
                '1:00pm',
                '1:30pm',
                '2:00pm',
                '2:30pm',
            ].map((time) => (
                <TimeButton key={time}>{time}</TimeButton>
            ))}
        </SlotsList>
    );
}

const Wrapper = styled.div`
    display: flex;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    height: 380px;
    width: 920px;
    margin: 0 auto;
    background-color: #fff;
    > div {
        height: 100%;
        padding: 16px;
        font-weight: 500;
        font-size: 13px;
    }
`;

const Sidebar = styled.div`
    width: 300px;
    border-right: 1px solid #e5e7eb;
`;

const CalendarWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const TimeslotsWrapper = styled.div`
    width: 250px;
    border-left: 1px solid #e5e7eb;
`;

const TimeslotHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

const SlotsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-y: hidden;
    align-items: center;
`;

const Heading = styled.div`
    font-size: 20px;
    font-weight: 600;
`;

const Subheading = styled.div`
    margin-top: 16px;
`;

const Info = styled.div`
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Calendar = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-top: 32px;
`;

const Day = styled.div`
    text-align: center;
    color: #6b7280;
`;

const DateCell = styled.div<{ isInvalidDay?: boolean }>`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${(props) => (props.isInvalidDay ? '#fff' : '#f3f4f6')};
    color: ${(props) => (props.isInvalidDay ? '#ccc' : '#000')};
    cursor: pointer;
    position: relative;
`;

const CurrentDateCell = styled(DateCell)`
    background-color: #111827;
    color: #fff;
    &:before {
        content: '.';
        position: absolute;
        color: #fff;
        width: 100%;
        font-size: 32px;
        bottom: 0;
        line-height: 1;
        text-align: center;
    }
`;

const TimeToggle = styled.div<{ active?: boolean }>`
    display: flex;
    gap: 8px;
    width: fit-content;
    justify-content: center;
    background-color: #f3f4f6;
    align-items: center;
    border-radius: 8px;
    padding: 6px;
    color: #3c3e44;
    box-sizing: border-box;
    border: 1px solid #e5e7eb;
`;

const TimeButton = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    height: 30px;
`;

export default CalBooking;
